import React from 'react';
import classNames from 'classnames';
import './index.scss';
import { CommonProps } from 'src/components/helpers/props';

export interface IProps extends CommonProps {
  size?: 'md' | 'sm' | 'lg';
  fill?: string;
}

const RequestPendingIcon: React.FC<IProps> = ({ classes, size = 'md', fill }) => {
  return (
    <svg
      className={classNames('icon-root', classes)}
      width="20"
      height="20"
      viewBox="0 0 20 20"
      color="#B5BBC2"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.25 1.56C7.25 1.25072 7.4552 1 7.70833 1H12.2917C12.5448 1 12.75 1.25072 12.75 1.56V3.24C12.75 3.54928 12.5448 3.8 12.2917 3.8H7.70833C7.4552 3.8 7.25 3.54928 7.25 3.24V1.56Z"
        fill="currentColor"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M5.5 2.5H6V3.5C6 4.32843 6.67157 5 7.5 5H12.5C13.3284 5 14 4.32843 14 3.5V2.5H14.5C15.8807 2.5 17 3.61929 17 5V16.5C17 17.8807 15.8807 19 14.5 19H5.5C4.11929 19 3 17.8807 3 16.5V5C3 3.61929 4.11929 2.5 5.5 2.5ZM8.0772 8.33452C8.30945 8.21022 8.59127 8.22384 8.81045 8.36997L12.3819 10.7509C12.5806 10.8834 12.7 11.1064 12.7 11.3452C12.7 11.5841 12.5806 11.8071 12.3819 11.9396L8.81045 14.3205C8.59127 14.4666 8.30945 14.4803 8.0772 14.356C7.84494 14.2317 7.69995 13.9896 7.69995 13.7262V8.96429C7.69995 8.70086 7.84494 8.45882 8.0772 8.33452Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default RequestPendingIcon;
